import { FillsGraphConfiguration } from './FillsGraphConfiguration';
import {
    WidgetSetConfigPayload,
    buildUpdateWidgetConfigurationActionCreator,
    WidgetSetConfigAction,
    createLoadWidgetConfigurationAction,
} from 'widgets/store/configuration/actions';
import { WidgetType } from 'widgets/WidgetType';

export type UpdateFillsGraphConfigurationPayload =
    WidgetSetConfigPayload<FillsGraphConfiguration>;

export type FillsGraphConfigAction =
    WidgetSetConfigAction<UpdateFillsGraphConfigurationPayload>;

export const updateFillsGraphConfiguration =
    buildUpdateWidgetConfigurationActionCreator<FillsGraphConfiguration>(
        WidgetType.FILLS_GRAPH
    );

export const loadFillsGraphConfiguration =
    createLoadWidgetConfigurationAction<FillsGraphConfiguration>(
        WidgetType.FILLS_GRAPH
    );
